(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["live-view-block"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.live-viewers').forEach(function (el) {
      var countEl = el.querySelector('.live-viewers__count');
      if (!countEl || countEl.dataset.bound === 'true') return;
      countEl.dataset.bound = 'true';

      var min = parseInt(el.dataset.min, 10) || 8;
      var max = parseInt(el.dataset.max, 10) || 19;

      function randomCount() {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      setInterval(function () {
        countEl.textContent = randomCount();
      }, 4000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
